import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { ListChecks } from '@phosphor-icons/react';
import { ClipboardPlus } from '../../../components/icons';
import { getChartStatusForTransmission } from './chartStatus';

export const CLICK_TO_VIEW_PATIENT_CHART = 'Click here to view Patient Chart';

const SUCCESS_STATUS_KEYS = new Set([
  'task_created',
  'task_after_chart_creation_success',
]);

const iconStyle = {
  marginRight: 4,
};

const buildIconNode = (statusKey, hasLink) => {
  if (!hasLink) return null;

  switch (statusKey) {
    case 'task_created':
      return <ListChecks size={18} color="#52c41a" style={iconStyle} />;
    case 'task_after_chart_creation_success':
      return <ClipboardPlus size={18} color="#52c41a" style={iconStyle} />;
    default:
      return null;
  }
};

export const openPatientChartLink = (event, link) => {
  if (!link) return;

  window.open(link, '_blank', 'noopener,noreferrer');
  event.stopPropagation();
  event.preventDefault();
};

export const getPatientInfoStatusConfig = (transmission = {}, options = {}) => {
  const status = getChartStatusForTransmission(transmission, options);

  if (!status || !SUCCESS_STATUS_KEYS.has(status.statusKey)) {
    return null;
  }

  const iconNode = buildIconNode(status.statusKey, Boolean(status.link));
  if (!iconNode) return null;

  return {
    ...status,
    iconNode,
  };
};

export const PatientInfoStatusIcon = ({ status }) => {
  if (!status || !status.iconNode || !status.link) return null;

  const tooltipTitle = (
    <span>
      {status.message}
      <br />
      <br />
      {CLICK_TO_VIEW_PATIENT_CHART}
    </span>
  );

  const iconNode = React.cloneElement(status.iconNode, {
    onClick: (event) => openPatientChartLink(event, status.link),
  });

  return (
    <Tooltip title={tooltipTitle}>
      {iconNode}
    </Tooltip>
  );
};

PatientInfoStatusIcon.defaultProps = {
  status: null,
};

PatientInfoStatusIcon.propTypes = {
  status: PropTypes.shape({
    message: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    iconNode: PropTypes.node.isRequired,
  }),
};
